import { Button, Col, Modal, Spinner } from "react-bootstrap";
import Form from "react-bootstrap/Form";
import React, { Component } from "react";
import {
  AddUserToDistrictRequest,
  BasicUserInfo,
  EmailCheckResponse,
  InvitesResponse,
  PopupDismissalKeys,
  ReactSelectOption,
  School,
  SuccessfulInvite,
  TeacherInfo
} from "../../../../store/onboarding/types";
import FailedInvitationsAlert from "./upload-educators/FailedInvitationsAlert";
import { ApplicationState } from "../../../../store";
import { bindActionCreators, Dispatch } from "redux";
import {
  checkEmailExist,
  createUserInDistrict,
  getTeachers,
  hideTeacherInviteIndividuallyModal,
  //openSchoolCreateModal,
  openUpsertSchoolModal,
  sendInviteToTeachers,
} from "../../../../store/onboarding/actions";
import { connect } from "react-redux";
import { PopupDismissal, UserAssignmentRole, UserInfo } from "../../../../store/auth/types";
import { districtOwnerAssignableRoles } from "../../../../store/onboarding/users-management/types";
import Select, { ValueType } from "react-select";
import CreatableSelect from "react-select/creatable";
import { districtRoles } from "../../../../store/auth/constants";
import { toastr } from "react-redux-toastr";
import { showConfirmDialog } from "../../../../store/confirm-dialog/actions";
import { faCircle, faExclamationCircle, faPlusCircle, faTimesCircle, faUndo, faUndoAlt } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { escapeSpecialCharacter, isShowConfimationDialog } from "../../../../utils/NamesUtils";

type State = {
  invites: Array<AddUserToDistrictRequest>;
  teacherOptions?: ReactSelectOption<BasicUserInfo>[];
  duplicateEmailExist: boolean;
};

type PropsFromState = {
  hasDistrictPermission?: boolean;
  schools: Array<School>;
  isLoading: {
    sendInviteToTeachers: boolean;
    addUserToDistrict: boolean;
    checkEmailExist: boolean;
  };
  errors?: {
    sendInviteToTeachers?: string;
  };
  invites: InvitesResponse;
  newTeacherForCreatable?: BasicUserInfo;
  modalShow: boolean;
  callback?: Function;
  districtUserName?: string;
  showFailedInvitationsAlert: boolean;
  currentRole?: string;
  teachersRoster?: TeacherInfo[];
  userDismissPopupDetails?: PopupDismissal
};

type DispatchProps = {
  createUserInDistrict: (invites: AddUserToDistrictRequest[]) => any;
  checkEmailExist: (inviteEmails:Array<any>) => any;
  sendInviteToTeachers: (invites: Array<BasicUserInfo>) => any;
  getTeachers: () => any;
  onModalHide: () => void;
  showConfirmDialog: (confirmObj: any) => any;
  openUpsertSchoolModal: (input: string, districtId: number, callback: Function) => any;
};

type Props = PropsFromState & DispatchProps;

class TeacherInviteIndividuallyModal extends Component<Props, State> {
  emptyInvite: AddUserToDistrictRequest = {
    existing_user_id: 0,
    first_name: "",
    last_name: "",
    email: "",
    role: undefined,
    schools: undefined,
    isSetValue: false
  };

  state: Readonly<State> = {
    invites: [],
    teacherOptions: [],
    duplicateEmailExist: false
  };
  

  componentDidUpdate(
    prevProps: Readonly<Props>,
    prevState: Readonly<State>
  ): void {
    const {
      newTeacherForCreatable,
      invites,
      getTeachers,
      onModalHide,
      teachersRoster
    } = this.props;

    if (
      prevProps.isLoading.sendInviteToTeachers &&
      !this.props.isLoading.sendInviteToTeachers
    ) {
      const { failed_invites, successful_invites } = invites;
      if (failed_invites.length > 0) {
        const newRawData = this.state.invites.filter(
          (invite) =>
            !successful_invites.find((successfulInvite: SuccessfulInvite) => {
              return successfulInvite.user.email.trim() === invite.email.trim();
            })
        );
        this.setState({ invites: newRawData });
      } else {
        getTeachers();

        if (this.props.callback) {
          this.props.callback(successful_invites);
        }
        if(!this.props.errors?.sendInviteToTeachers) {
          onModalHide();
        }
      }
    }
    if (!prevProps.modalShow && this.props.modalShow) {
      if (newTeacherForCreatable) {
        this.setState({
          invites: [
            {
              first_name: newTeacherForCreatable.first_name,
              last_name: newTeacherForCreatable.last_name,
              email: newTeacherForCreatable.email,
            },
          ],
        });
      }

      this.setState({
        teacherOptions: 
          teachersRoster!
          .filter((teacherRoster) => teacherRoster.user.profile.current_role == UserAssignmentRole.NJTSS_IMPORTED_USER)
          .map((st) => ({
            label: st.user.first_name + " " + st.user.last_name,
            value: st.user,
          })) as any
      });
    }
  }


  handleOnEnter = () => {
    this.setState({
      invites: [this.emptyInvite],
    });
  };

  handleAddInvite = () => {
    this.setState((prevState) => ({
      ...prevState,
      invites: [...prevState.invites, this.emptyInvite],
    }));
  };

  handleRemove = (recIndex:number) => {
    const invites = this.state.invites;
    this.setState((prevState) => ({
      ...prevState,
      invites: [...invites.filter((invite, index) => recIndex !== index)],
    }));
  };

  handleReset = (recIndex:number) => {
    this.setState((state) => ({
      ...state,
      invites: state.invites.map((invite: BasicUserInfo, index) => {
        if (index === recIndex) {
          return {
            ...invite,
            existing_user_id: 0,
            first_name: "",
            last_name: "",
            email: "",
            role: undefined,
            schools: undefined,
            isSetValue: false
            
          };
        }
        return invite;
      }) 
    }), () => {
      document.getElementById(`email_${recIndex}`)!.style.border="";
      document.getElementById(`email_msg_${recIndex}`)!.innerHTML="";
    });
  };

  handleInviteSelectChange = (selectedIndex: number) => (
    selectValue: ValueType<ReactSelectOption<BasicUserInfo>, false>
  ) => {
    const splitInput = (selectValue as ReactSelectOption<BasicUserInfo>)?.label.trim().split(" ");
    const extraUserInfo = (selectValue as ReactSelectOption<UserInfo>)?.value;
    this.setState((state) => ({
      ...state,
      invites: state.invites.map((invite: BasicUserInfo, index) => {
        if (index === selectedIndex) {
          return {
            ...invite,
            existing_user_id: extraUserInfo.id || 0,
            first_name: escapeSpecialCharacter(splitInput![0]),
            last_name: escapeSpecialCharacter(splitInput![1] || ""),
            email: !extraUserInfo.email.includes('@njtss_user_imported') ? extraUserInfo.email: "",
            role: extraUserInfo.profile.current_role,
            schools: extraUserInfo.profile.current_assignment?.schools.map((school: School) => school.id),
            isSetValue: true
          };
        }
        return invite;
      })
    }), () => {
      // this.setState({
      //   teacherOptions: this.state.teacherOptions?.filter((teacher) => 
      //                     !this.state.invites.some((invite) => invite.id == teacher.value.id))
      // })
    });
  };

  handleInviteChange = (selectedIndex: number) => (
    event: React.FormEvent<any>
  ) => {
    const { name, value } = event.target as HTMLInputElement;
    let sanitizedValue = value

    if (name === "first_name" || name === "last_name") {
    sanitizedValue = escapeSpecialCharacter(value);
    }

    this.setState((state) => ({
      ...state,
      invites: state.invites.map((invite: BasicUserInfo, index) => {
        if (index === selectedIndex) {
          return {
            ...invite,
            [name]: sanitizedValue,
            isSetValue: true
            
          };
        }
        return invite;
      })
    }), () => {
      if (name === "email") {
      sanitizedValue = value;
      const input = document.getElementById(`email_${selectedIndex}`);
      const msg = document.getElementById(`email_msg_${selectedIndex}`);
      if (input) input.style.border = "";
      if (msg) msg.innerHTML = "";
    }
      const inviteEmails = this.state.invites.map((invite) => invite.email);
      const duplicateEmails: { [key: number]: string } = {};
      const frequency: { [key: string]: number } = {};

      // Build frequency map (exclude empty emails)
      inviteEmails.forEach(email => {
        if (email && email.trim()) {
          frequency[email] = (frequency[email] || 0) + 1;
        }
      });

      // Identify duplicates + highlight UI
      inviteEmails.forEach((email, index) => {
        if (email && email.trim() && frequency[email] > 1) {
          duplicateEmails[index] = email;

          const input = document.getElementById(`email_${index}`);
          const msg = document.getElementById(`email_msg_${index}`);

          if (input) input.style.border = "1px solid red";
          if (msg) msg.innerHTML = "The highlighted email is the same as another. Please use a different email.";
        }
      });

      // If duplicates exist, adjust icons and STOP execution
      if (Object.keys(duplicateEmails).length > 0) {
        const elements = document.querySelectorAll('.icon_adjust_class');
        elements.forEach(el => {
          el.classList.remove('align-items-center');
          el.classList.add('mt-4');
        });
        this.setState({
          ...this.state,
          duplicateEmailExist: true
        })
      } else {
        if(this.state.duplicateEmailExist){
           inviteEmails.forEach((_, selectedIndex) => {
            document.getElementById(`email_${selectedIndex}`)!.style.border="";
            document.getElementById(`email_msg_${selectedIndex}`)!.innerHTML="";
           })
        }
        this.setState({
          ...this.state,
          duplicateEmailExist: false
        })
      }
    });
  };

  handleCreateInvite = (selectedIndex: number) => (input: string) => {
    const splitInput = input.split(" ");
    this.setState((state) => ({
      ...state,
      invites: state.invites.map((invite: BasicUserInfo, index) => {
        if (index === selectedIndex) {
          return {
            ...invite,
            existing_user_id: 0,
            first_name: escapeSpecialCharacter(splitInput![0]),
            last_name: escapeSpecialCharacter(splitInput![1] || ""),
            email: splitInput![2] || "",
            isSetValue: true
            
          };
        }
        return invite;
      })
    }));
  };



  createUserByDistrict = () => {
    this.props.createUserInDistrict(this.state.invites).then(
      () => {
        this.handleModalClose(true);
        toastr.success(
          "Success",
          `The invitation has been sent successfully.`
          );
      },
      (err: any) =>  toastr.error("Error", err)
    //     //  todo handle failed invites
     );
  }

  createUser = () => {
    if(isShowConfimationDialog(this.props.userDismissPopupDetails?.[PopupDismissalKeys.TEACHER_INVITE_CREATE_USER])) {
      this.props.showConfirmDialog({
        onConfirm: () => {
          this.createUserByDistrict();
        },
        centered: true,
        size:'',
        title: "Coach–Teacher Assignment",
        timerElipseLeft: true,
        // countDownTimer: 3,
        text: (
          <p className="text-center">
            For coaches and teachers to share data and collaborate on intervention cases, 
            teachers must be assigned to a coach. This can be done from the <strong>Actions</strong> menu in My Staff.
          </p>
        ),
        confirmButtonText: "Continue",
        popupKey: PopupDismissalKeys.TEACHER_INVITE_CREATE_USER
      });
    } else {
      this.createUserByDistrict();
    }
  };

  handleInviteSend = (event: React.FormEvent<any>) => {
    event.preventDefault();
    const invities = this.state.invites;
    let isRequiredFlag = false;
    let isRequiredSelectFlag = false;
    let isRequiredSchoolFlag = false;
    for (let i = 0; i < invities.length; i++) {
      const element = invities[i];
      if(!element.first_name) {
        isRequiredSelectFlag = true;
        break;
      }
    }
    if(isRequiredSelectFlag) {
      toastr.error('Alert', 'Please add First Name.')
      return;
    }
    if (this.props.hasDistrictPermission) {
      for (let i = 0; i < invities.length; i++) {
        const element = invities[i];
        if(element.role == undefined) {
          isRequiredFlag = true;
          break;
        }  
        if (
          element.schools === undefined ||
          (Array.isArray(element.schools) && element.schools.length === 0)
        ) {
          isRequiredSchoolFlag = true;
          break;
        }
      }
      if(isRequiredFlag) {
        toastr.error('Alert', 'Please select Account Type.');
        return;
      }
      if(isRequiredSchoolFlag) {
        toastr.error('Alert', 'Please add School(s).');
        return;
      }

      const inviteEmails = this.state.invites.map((invite) => invite.email);
        
        this.props.checkEmailExist(inviteEmails)
        .then((result:EmailCheckResponse) => {
          if(!result.emails_already_exist.length && !Object.keys(result.invalid_emails).length) {
            if(invities.some((invite) =>
                [UserAssignmentRole.DISTRICT_OWNER, UserAssignmentRole.COACH, UserAssignmentRole.TEACHER].includes(invite?.role!)
            )) {
                if(isShowConfimationDialog(this.props.userDismissPopupDetails?.[PopupDismissalKeys.TEACHER_INVITE_SEND])) {
                  this.props.showConfirmDialog({
                    onConfirm: () => {
                      this.createUser();
                    },
                    centered: true,
                    size:'',
                    title: "Confirm Account Type",
                    timerElipseLeft: true,
                    // countDownTimer: 3,
                    text: (
                      <>
                        <p className="text-center font-weight-bold">Are you sure you want to continue?</p>
                        <p className="text-center">The assigned account type is permanent and cannot be changed.</p>
                      </>
                    ),
                    confirmButtonText: "Confirm",
                    popupKey: PopupDismissalKeys.TEACHER_INVITE_SEND
                  });
                } else {
                  this.createUser();
                }
            } else {
              this.createUser()
            }
          } else {
            //toastr.error("Alert", 'Highlighted email(s) already exist. Please use different email(s).')
            invities.map((invite,index) => {
              if(result.invalid_emails[invite.email]){
                document.getElementById(`email_${index}`)!.style.border="1px solid red";
                document.getElementById(`email_msg_${index}`)!.innerHTML= result.invalid_emails[invite.email];
                const elements = document.querySelectorAll('.icon_adjust_class');
                elements.forEach(el => {
                  el.classList.remove('align-items-center');
                  el.classList.add('mt-4');
                });
              }
              if(result.emails_already_exist.some((existingEmail:string) => existingEmail == invite.email)){
                document.getElementById(`email_${index}`)!.style.border="1px solid red";
                document.getElementById(`email_msg_${index}`)!.innerHTML="Email already exist. Please use different email.";
                const elements = document.querySelectorAll('.icon_adjust_class');
                elements.forEach(el => {
                  el.classList.remove('align-items-center');
                  el.classList.add('mt-4');
                });
              }
              if(!result.invalid_emails[invite.email] && !result.emails_already_exist.some((existingEmail:string) => existingEmail == invite.email)) {
                if(result.new_emails.some((newEmail:string) => newEmail == invite.email)) {
                  document.getElementById(`email_${index}`)!.style.border="";
                  document.getElementById(`email_msg_${index}`)!.innerHTML="";
                  const elements = document.querySelectorAll('.icon_adjust_class');
                  elements.forEach(el => {
                    el.classList.remove('mt-4');
                    el.classList.add('align-items-center');
                  });
                }
              }
            })
          }
        },
        (err: any) =>  toastr.error("Error", err)
      )
    } else {
      this.props.sendInviteToTeachers(this.state.invites).then(
        (invitesResponse: InvitesResponse) => {
        if(!this.props.showFailedInvitationsAlert && !this.props.errors?.sendInviteToTeachers && invitesResponse.successful_invites.length){
          toastr.success(
            "Success",
            `You have invited new user(s) to ReadyCoach. Your district admin (${this.props.districtUserName}) has been contacted to establish data permissions for the invited user to access shared data.`
          );
        }
        },
        (err: string) => console.log('send invite failed',err)
      );
    }
    
    
  };

  handleModalClose = (isUpdated: boolean) => {
    const { getTeachers, onModalHide, isLoading } = this.props;
    if (!isLoading.sendInviteToTeachers) {
      if(isUpdated) {
        getTeachers(); //todo need to optimize
      }
      onModalHide();
      this.setState({
        invites: [this.emptyInvite],
      });
    }
  };

  handleRoleChange = (selectedIndex: number) => (
    role: ValueType<ReactSelectOption<string>, false>
  ) => {
    this.setState((state) => ({
      ...state,
      invites: state.invites.map((invite: BasicUserInfo, index) => {
        if (index === selectedIndex) {
          return {
            ...invite,
            role: (role as ReactSelectOption<string>)
              ?.value as UserAssignmentRole,
          };
        }
        return invite;
      }),
    }));
  };

  handleSchoolsChange = (selectedIndex: number, newValue?: ValueType<School, true>,) => {
    const newSchools = newValue
      ? (newValue as Array<School>).map((val) => val.id)
      : [];
    this.setState((state) => ({
      ...state,
      invites: state.invites.map((invite: BasicUserInfo, index) => {
        if (index === selectedIndex) {
          return {
            ...invite,
            schools: newSchools
          };
        }
        return invite;
      }),
    }));
  };

  handleCreateSchool = (selectedIndex: number) => (input:string) => {
    this.props.openUpsertSchoolModal(input, 0, (newSchool: School) =>
      this.setState((state) => ({
        ...state,
        invites: state.invites.map((invite: BasicUserInfo, index) => {
           if (index === selectedIndex) {
            invite = {
              ...invite,
              schools: [...(invite?.schools ?? []), newSchool?.id]
            }
           }
           return invite;
        }),
      }))
    )
  }

  render() {
    const { invites } = this.state;
    const { hasDistrictPermission, schools } = this.props;
    const isDistrictOwner = this.props.currentRole == UserAssignmentRole.DISTRICT_OWNER;
    const mdStyle = isDistrictOwner ? `col-md-2` : 'col-md-3';
    return (
      //@ts-ignore
      <Modal
        show={this.props.modalShow}
        animation={false}
        backdropClassName="customDarkModalBackdrop in"
        //@ts-ignore
        onShow={this.handleOnEnter}
        onHide={() => this.handleModalClose(false)}
        size={ isDistrictOwner ? 'xl': 'lg'}
        className="teacher-invite-individually-modal"
        centered
      >
        <Modal.Header
          closeButton
          className="purpleModalHeader orangeModalHeader"
        >
          <Modal.Title>Invite Individually</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          {hasDistrictPermission ?
             <div className="row col-auto" style={{marginLeft: "10px"}}>
              <span className="alert alert-warning p-1">
                Data permissions must be established for invited users to view data within the system. Please refer to <strong>Manage Data Permissions</strong> to set them up.
              </span>
            </div>
             : ''
          }

          <h4 className="mb-3" style={{marginLeft: "22px"}}>
            Enter the user’s details, then click <strong>Send Invite</strong>.
            ReadyCoach will email the user with instructions for joining.
          </h4>
          <div className="mb-1" style={{marginLeft: "22px", color: "red"}}>
            <small>
              <i>Fields marked with <strong>*</strong> are required.</i>
            </small>
          </div>
          <FailedInvitationsAlert />
            <form id="newInviteForm12" onSubmit={this.handleInviteSend}>
              {invites.map((invite, index) => (
                <Form.Row key={`invite_${index}`} className="d-flex">
                  <div className="d-flex icon_adjust_class align-items-center mr-2"> 
                    {invite.existing_user_id! > 0 ? <FontAwesomeIcon
                        icon={faExclamationCircle}
                        size="lg"
                        className="purpleText"
                        title="This user is imported from file. The invitation will be sent to this existing user."
                      /> : <span style={{width: "21px"}}></span> }
                  </div>
                  <div className="individualInviteContainer">
                      <div className={mdStyle}>
                        {!invite.isSetValue 
                        ?
                        <CreatableSelect
                          menuPortalTarget={document.body}
                          menuPosition="fixed"
                          styles={{
                          control: (base) => ({
                            ...base,
                            height: "35px",
                            minHeight: "35px",
                          }),
                          menuPortal: (base) => ({ ...base, zIndex: 10050 }),
                          }}
                          createOptionPosition="first"
                          onChange={this.handleInviteSelectChange(index)}
                          onCreateOption={this.handleCreateInvite(index)}
                          onInputChange={(inputValue) => {
                          const sanitized = escapeSpecialCharacter(inputValue);
                          this.setState((state) => ({
                            ...state,
                            invites: state.invites.map((inv, i) =>
                            i === index ? { ...inv, first_name: sanitized } : inv
                            ),
                          }));
                          }}
                          inputValue={this.state.invites[index]?.first_name ?? ""}
                          formatCreateLabel={(input: string) =>
                          `Add new '${escapeSpecialCharacter(input)}'`
                          }
                          allowCreateWhileLoading
                          options={this.state.teacherOptions as any}
                          placeholder="First Name *"
                          name="first_name"
                        />
                        :
                        <Form.Control
                          style={{
                          height: "35px",
                          minHeight: "35px",
                          }}
                          required
                          name="first_name"
                          onChange={this.handleInviteChange(index)}
                          value={invite.first_name}
                        />
                        }
                      </div>
                      <div className={mdStyle}>
                        <Form.Control
                          style={{
                            height: "35px",
                            minHeight: "35px",
                          }}
                          required
                          placeholder="Last Name *"
                          name="last_name"
                          onChange={this.handleInviteChange(index)}
                          value={invite.last_name}
                          readOnly={!invite.first_name}
                        />
                      </div>
                      <div className={isDistrictOwner ? `col-md-3` : 'col-md-5'}>
                        <Form.Control
                          required
                          type="email"
                          placeholder="Email *"
                          name="email"
                          onChange={this.handleInviteChange(index)}
                          // onBlur={() => {
                          // const email = this.state.invites[index]?.email?.trim();
                          // if (!email) return;
                          // this.props
                          //   .checkEmailExist([email])
                          //   .then((result: EmailCheckResponse) => {
                          //   if (result.emails_already_exist?.some((e) => e === email)) {
                          //     const el = document.getElementById(`email_${index}`);
                          //     if (el) el.style.border = "1px solid red";
                          //     toastr.error("Alert", 'Highlighted email(s) already exist. Please use different email(s).');
                          //   } else {
                          //     const el = document.getElementById(`email_${index}`);
                          //     if (el) el.style.border = "";
                          //   }
                          //   })
                          //   .catch((err:any) => {
                          //   console.error("Email check failed", err);
                          //   });
                          // }}
                          value={invite.email}
                          id={`email_${index}`}
                          readOnly={!invite.first_name}
                        />
                        <div id={`email_msg_${index}`} style={{color:"red"}}></div>
                      </div>
                      {hasDistrictPermission && (
                        <>
                          <div className={"col-md-2"}>
                            <Select
                              menuPortalTarget={document.body}
                              menuPosition="fixed"
                              styles={{
                                control: (base, state) => ({
                                  ...base,
                                  height: "35px",
                                  minHeight: "35px",
                                }),
                                menuPortal: (base) => ({ ...base, zIndex: 10050 }),
                              }}
                              isClearable
                              name="roles"
                              placeholder="Account Type *"
                              options={districtOwnerAssignableRoles.filter((dist)=> ['District Admin','Coach','Teacher'].includes(dist.label))}
                              value={invite.role != undefined ? districtOwnerAssignableRoles.find(
                                (role) => role.value === invite.role
                              ): null}
                              onChange={this.handleRoleChange(index)}
                              isDisabled={!invite.first_name || !!invite.existing_user_id}
                            />
                          </div>
                          <div className="col-md-3 d-flex align-items-top">
                            <div className="flex-grow-1">
                              <CreatableSelect
                                isMulti
                                createOptionPosition="first"
                                menuPortalTarget={document.body}
                                menuPosition="fixed"
                                styles={{
                                  menuPortal: (base) => ({ ...base, zIndex: 10050 }),
                                }}
                                onChange={(selectedOption:any) => this.handleSchoolsChange(index, selectedOption)}
                                onCreateOption={this.handleCreateSchool(index)}
                                formatCreateLabel={(input: string) =>
                                  `Add new ${input}`
                                }
                                allowCreateWhileLoading
                                options={schools}
                                placeholder="School(s) *"
                                name="schools"
                                isDisabled={!invite.first_name}
                                value={schools.filter((school) =>
                                  invite.schools?.find((iSchool) => iSchool === school.id)
                                )}
                                getOptionLabel={(school: any) => school.label ?? school.name}
                                getOptionValue={(school: any) => school.value ?? school.id}
                                noOptionsMessage={
                                  ((() => (schools?.length >= 1) && (invite.schools?.length == schools?.length) 
                                  ? "No options"
                                  : (
                                    <button
                                      className="blueBtnSm"
                                      onClick={() => this.props.openUpsertSchoolModal("", 0, (newSchool: School) =>
                                        this.setState((state) => ({
                                          ...state,
                                          invites: state.invites.map((invite: BasicUserInfo, stateIndex) => {
                                            if (stateIndex === index) {
                                              invite = {
                                                ...invite,
                                                schools: [...(invite?.schools ?? []), newSchool?.id]
                                              }
                                            }
                                            return invite;
                                          }),
                                        }))
                                      )}
                                    >
                                      Add School
                                    </button>
                                  )) as any)
                              }
                              />
                            </div>
                          </div>
                        </>
                      )}
                  </div>
                        {(index > 0) ? 
                        <div className="d-flex icon_adjust_class align-items-center">
                          <>
                          {invite.first_name || invite.last_name || invite.email ? 
                            <span className={invite.first_name || invite.last_name || invite.email ? `circle` : `circle-transparent`} onClick={() => this.handleReset(index)}>
                              <FontAwesomeIcon
                                icon={faUndoAlt}
                                size="lg"
                                title="Reset"
                                />
                            </span> 
                            : ''}
                            <span className="mx-1 removeIconBtn" onClick={() => this.handleRemove(index)}>
                              <FontAwesomeIcon
                                icon={faTimesCircle}
                                color="red"
                                size="lg"
                                title="Remove"
                                /></span>
                          </>
                        </div> 
                        : <div className="d-flex icon_adjust_class align-items-center ml-1">
                            {invite.first_name || invite.last_name || invite.email ? 
                            <span className="circle" onClick={() => this.handleReset(index)}>
                              <FontAwesomeIcon
                                icon={faUndoAlt}
                                size="lg"
                                title="Reset"
                                />
                          </span>
                            : ''}
                          </div>}
                </Form.Row>
              ))}
            </form>
          <div className="leftActions d-flex flex-column align-items-start mt-3" style={{marginLeft: "22px"}}>
            <Button
              bsPrefix="b"
              className="blueBtnSm"
              onClick={this.handleAddInvite}
            >
              <FontAwesomeIcon icon={faPlusCircle} className="mr-1" style={{ color: "white", marginRight: "6px" }} />
              Add Another User
            </Button>
          </div>
          <hr style={{marginLeft: "22px"}}/>
          <div className="d-flex justify-content-end pr-0">
              <div className="d-flex" style={{ gap: "8px" }}>
              <Button
                disabled={this.props.isLoading.sendInviteToTeachers}
                bsPrefix="b"
                onClick={this.props.onModalHide}
                className="whiteBtnSm"
              >
                Cancel
              </Button>
                <button
                form="newInviteForm12"
                type="submit"
                className="blueBtnSm"
                disabled={
                  this.props.isLoading.sendInviteToTeachers ||
                  this.props.isLoading.addUserToDistrict ||
                  this.props.isLoading.checkEmailExist ||
                  this.state.duplicateEmailExist ||
                  this.state.invites.some((invite) =>
                  !invite.first_name ||
                  !invite.last_name ||
                  !invite.email ||
                  (this.props.hasDistrictPermission &&
                    (invite.role === undefined ||
                    !invite.schools ||
                    (Array.isArray(invite.schools) && invite.schools.length === 0)))
                  )
                }
                >
                Send Invite{" "}
                {(this.props.isLoading.sendInviteToTeachers ||
                this.props.isLoading.addUserToDistrict ||
                this.props.isLoading.checkEmailExist
                ) && (
                <Spinner animation="border" size="sm" />
                )}
              </button>
              </div>
            </div>
        </Modal.Body>
      </Modal>
    );
  }
}

const mapStateToProps = ({
  auth,
  onboarding,
}: ApplicationState): PropsFromState => ({
  hasDistrictPermission:
    auth.userInfo?.profile.current_assignment?.role &&
    districtRoles.includes(auth.userInfo.profile.current_assignment.role),
  districtUserName: auth.userInfo?.profile.district?.owner.first_name + " " + auth.userInfo?.profile.district?.owner.last_name,
  currentRole: auth.userInfo?.profile.current_assignment?.role,
  modalShow: onboarding.modalsState.teachersIndividuallyInviteModal,
  callback: onboarding.modalsState.teachersIndividuallyInviteModalCallback,
  invites: onboarding.invites,
  newTeacherForCreatable: onboarding.newTeacherForCreatable,
  errors: { sendInviteToTeachers: onboarding.errors.sendInviteToTeachers },
  isLoading: {
    sendInviteToTeachers: onboarding.isLoading.sendInviteToTeachers,
    addUserToDistrict: onboarding.isLoading.addUserToDistrict,
    checkEmailExist: onboarding.isLoading.checkEmailExist
  },
  showFailedInvitationsAlert: onboarding.modalsState.showFailedInvitationsAlert,
  teachersRoster: onboarding.teachersRoster,
  schools: onboarding.schools,
  userDismissPopupDetails: auth.userInfo?.user_dismiss_pop_up_details
});

const mapDispatchToProps = (dispatch: Dispatch): DispatchProps =>
  bindActionCreators(
    {
      createUserInDistrict: createUserInDistrict,
      checkEmailExist: checkEmailExist,
      sendInviteToTeachers: sendInviteToTeachers,
      onModalHide: hideTeacherInviteIndividuallyModal,
      getTeachers: getTeachers,
      showConfirmDialog: showConfirmDialog,
      openUpsertSchoolModal: openUpsertSchoolModal
    },
    dispatch
  );

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(TeacherInviteIndividuallyModal);